import CpAvailabilityModal from "@components/CpAvailabilityModal";
import RefreshAndFocusHandler from "@components/HOC/RefreshAndFocusHandler";
import LoginInfo from "@components/LoginInfo";
import ShareDialog from "@components/ShareDialog";
import UpdateAppModal from "@components/UpdateAppModal";
import WelcomeCLtoCL from "@components/WelcomeCLtoLC";
import t from "@constants/localization";
import testIds from "@constants/testIds";
import { getItem, setItem, removeItem } from "@lib/storage";
import { useFocusEffect, useRoute } from "@react-navigation/native";
import { actions as miscActions } from "@reducers/miscReducer";
import analytics from "@services/analytics";
import refreshHOC from "@utils/refreshHOC";
import React, { memo, useCallback, useEffect, useRef } from "react";
import { Alert, BackHandler, Text, Touchable, View } from "react-native";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import strings from "@constants";
import { HOME_SCREEN } from "../../constants/analyticsEvents";
import { STATE_STATUS } from "../../reducers/actionTypes";
import ClAddressModal from "./ClAddressModal";
import HomePageSkeleton from "./HomeSkeleton";
import HeaderAndCms from "./HeaderAndCms";
// Plotline integration removed

const PATH = "screens/Home/index";

const { refresh: refreshScreenName } = strings;
const HomeTabView = memo((props) => {
  const { navigation } = props;
  const dispatch = useDispatch();
  const backHandler = useRef(null);
  const screenName = useRoute().name;

  const user = useSelector((state) => state.auth.user, shallowEqual);
  const config = useSelector((state) => state.configReducer, shallowEqual);

  useFocusEffect(
    useCallback(() => {
      backHandler.current = BackHandler.addEventListener(
        "hardwareBackPress",
        onBackPress,
      );
      dispatch(miscActions.setHomeMounted());
      return () => {
        if (backHandler.current) {
          backHandler.current.remove();
        }
        dispatch(miscActions.setHomeUnMounted());
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []),
  );

  useEffect(() => {
    analytics.trackScreen(HOME_SCREEN);
    dispatch(miscActions.setHomeMounted());
    // Check for contacts here
    (async () => {
      try {
        if (config.status === STATE_STATUS.FETCHED) {
          if (config.checkClOrderRating === true) {
            navigation.navigate("RateOrder", {
              for_order: false,
              modal: true,
              delivered_at: props.config.checkClOrderRating,
            });
          }
        }
        const [lastRatingModalShown] = await Promise.all([
          getItem("lastRatingModalShown"),
          removeItem("shouldShowBannersPopUp"),
          setItem("shouldShowBannersPopUp", "true"),
        ]);
        if (!lastRatingModalShown) {
          await setItem(
            "lastRatingModalShown",
            `${new Date().getTime()}`,
          );
        }
      } catch (e) {
        console.log(e);
      }
    })();

    return () => {
      dispatch(miscActions.setHomeUnMounted());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onBackPress = () => {
    if (
      props.route &&
      props.route.name === "Home" &&
      user.leader_state !== "PAYMENT_PENDING"
    ) {
      Alert.alert(
        t(`${PATH}/exit`),
        t(`${PATH}/cnfmExit`),
        [
          {
            onPress: () => BackHandler.exitApp(),
            text: t(`${PATH}/yes`),
          },
          {
            style: "cancel",
            text: t(`${PATH}/no`),
          },
        ],
        { cancelable: false },
      );
      return true;
    } else {
      return false;
    }
  };

  if (config.status === STATE_STATUS.FETCHED) {
    return (
      <View style={{ flex: 1 }} testID={testIds.Home_Visivle}>
        <LoginInfo navigation={navigation} />
        <ClAddressModal />
        <UpdateAppModal />
        {}
        <HeaderAndCms {...props} />
        <ShareDialog />
        {navigation.isFocused() && <WelcomeCLtoCL />}
        <CpAvailabilityModal />
      </View>
    );
  } else {
    return (
      <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
        <HomePageSkeleton
          style={{
            position: "absolute",
            top: 110,
            backgroundColor: "#f3f3f3",
            zIndex: 100,
          }}
        />
      </View>
    );
  }
});

export default RefreshAndFocusHandler(
  refreshHOC(refreshScreenName.home)(HomeTabView),
);
